<script>
import axios from "axios";
import simplebar from "simplebar-vue";

import i18n from "../i18n";
import { authComputed } from "@/state/helpers";
import gql from "graphql-tag";
import moment from "moment";
/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      userT: this.$store.state.authfack.user,
      userData : {},
      languages: [
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Español",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      myVar: 1,
    };
  },
  apollo: {
   
    getAllPartos: {
      query: gql`
        query Notificaciones($fecha_traslado: Date!) {
          getAllPartos(fecha_traslado: $fecha_traslado) {
            id
            no_inseminacion
            fecha_traslado
            idRecibe
            recibe {
              id
              no_lote
              fecha_inicio
            }
            cerdo{
              id
              codigo
            }
          }
        }
      `,
      variables() {
        return {
          // usuario:this.$props.user,
          fecha_traslado: this.customFormatter(new Date()),
        };
      },
      pollInterval: 86400000,
    },
  },

  components: {
    simplebar,
  },
  
  async mounted () {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    await this.getUserById();
  },
  methods: {
    async getUserById (){
      const response = await axios
        .get(
          process.env.VUE_APP_URL +
            "users/sectById?id=" +
            this.$store.state.authfack.user.id,
          {
            headers: { "x-token": this.userT.token },
          }
        );
        // console.log(response);
        this.userData.user = response.data.data.usuario;
          this.userData.tienda = response.data.data.empleado.tienda.nombre_tienda;
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    // async leido(id) {
    //   await this.$apollo.mutate({
    //     mutation: gql`
    //       mutation ($id: ID!) {
    //         notificacionLeida(id: $id) {
    //           id
    //         }
    //       }
    //     `,
    //     variables: {
    //       id: id,
    //     },
    //   });
    // },
    number(value) {
      if (typeof value != "undefined") return value.length;
    },
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      console.log( this.apiUrl)
      axios.get( this.apiUrl +  "/logout").then(() => {
        this.$router.push({
          name: "default",
        });
      });
    },
  },
  computed: {
    ...authComputed,
    
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <!-- Aca esta el logotipo del navbar -->
        <!-- Logo del navbar -->
        <div class="navbar-brand-box">
  <router-link to="/">
    <img class="logo-img" src="../../src/assets/cerdos/granja.png" alt="Logo">
  </router-link>
</div>



        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>


        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>
        <!-- Notificacion Productos -->
        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
            </a>
         </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown>
        <!-- Notificacion pagos -->
        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-user bx-tada"></i>
            <span v-if="$apollo.data" class="badge bg-danger rounded-pill">{{
              number(getAllPartos)
            }}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href="javascript: void(0);" class="text-reset notification-item">
              <div
                class="d-flex"
                v-for="(n, index) in getAllPartos"
                :key="index"
              >
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ "CERDOS PARA TRASLADO" }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1" v-if="n.recibe.id!=null">
                      {{
                        
                        "El Lote " +
                        n.recibe.no_lote +
                        " tiene el cerdo: " +
                        n.cerdo.codigo + " Debe ser enviado a Lote de parto"
                      }}
                    </p>
                     <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p> 
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown>

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
         
            <span class="d-none d-xl-inline-block ms-1">
              <div >
              </div>
             <div > 
                {{ userT.username }} {{ userT.nombre_tienda }} </div>
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
       
          <b-dropdown-divider></b-dropdown-divider>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
        </b-dropdown>

      </div>
    </div>
  </header>
</template>

<style scoped>

.navbar-brand-box {
  display: flex;
  align-items: center;  /* Centramos verticalmente el logo */
  justify-content: center; /* Centramos horizontalmente el logo */
  height: 120px;  /* Altura ligeramente más grande para mejor visibilidad */
  background-color: #2f323a; /* Fondo oscuro para que el logo resalte */
  padding: 10px 0; /* Añadir un poco de separación arriba y abajo */
}

.logo-img {
  max-width: 90px; /* Tamaño un poco más grande del logo para hacerlo más visible */
  height: auto;
  transition: transform 0.3s ease-in-out;
}

.logo-img:hover {
  transform: scale(1.15); /* Aumenta ligeramente al pasar el mouse para mayor énfasis */
}

@media (max-width: 768px) {
  .logo-img {
    max-width: 70px; /* Ajuste del tamaño para pantallas más pequeñas */
  }
  
  .navbar-brand-box {
    height: 100px; /* Ajustar la altura para pantallas pequeñas */
  }
}


</style>
